import { useTranslation } from 'react-i18next';
import SearchIcon from 'components/atoms/icons/search.svg?react';
import EmptyTablePlaceholder from 'components/atoms/base-empty-table-placeholder';
import BaseTableNew from 'components/atoms/base-table/new';
import useUser from 'utils/useUser';

import s from './styles.module.scss';
import { useColumns } from './columns';
import { PAGE_SIZE } from '../../constants';
import MobileTable from './mobile-table';

import type { IRpmPatientActivity } from 'infrastructure/interfaces/i-rpm-patient-activity';
import type { FC } from 'react';

interface ReadingTableProps {
  page: number;
  activity: IRpmPatientActivity | undefined;
  isLoading: boolean;
  name: string;
}

const ReadingTable: FC<ReadingTableProps> = ({
  page,
  activity,
  isLoading,
  name,
}) => {
  const { isMobileDevice } = useUser();
  const columns = useColumns({ page, items: PAGE_SIZE, name });

  const { t } = useTranslation();

  if (isMobileDevice) {
    return (
      <MobileTable
        activity={activity}
        page={page}
        isLoading={isLoading}
        name={name}
      />
    );
  }

  return (
    <BaseTableNew
      dataCy="patient-readings-table"
      loading={isLoading}
      columns={columns}
      items={activity?.data ?? []}
      bordered
      rowKey="guid"
      className={s.table}
      emptyText={
        <EmptyTablePlaceholder
          text={t('labels.noReadingsFound')}
          icon={<SearchIcon width={100} height={100} />}
          column
        />
      }
      rowHoverable={false}
      rowClassName={s['table-row']}
    />
  );
};

export default ReadingTable;
